import { Observable } from 'rxjs';
import { ViewportScroller } from '@angular/common';

import { AutocompletePlaces } from '@search-bar/entities/autocomplete-places';
import { BaseSearchBarFacade } from '@shared/base-search-bar/base-search-bar-facade';
import { AutocompletePlace } from '@shared/base-search-bar/entities/autocomplete';
import { ChangeInputPayload } from '@shared/base-search-bar/entities/search-input-payload';

export class AutoSearchAbstract {
  constructor(
    protected baseSearchbarfacade: BaseSearchBarFacade,
    protected viewportScroller: ViewportScroller
  ) { }

  get isDiffPlace$(): Observable<boolean> {
    return this.baseSearchbarfacade.autoDiffPlace$;
  }

  get autoCompletePlaces$(): Observable<AutocompletePlaces> {
    return this.baseSearchbarfacade.autoCompletePlaces$;
  }

  get departurePlace$(): Observable<AutocompletePlace> {
    return this.baseSearchbarfacade.departurePlace$;
  }

  get arrivalPlace$(): Observable<AutocompletePlace> {
    return this.baseSearchbarfacade.arrivalPlace$;
  }
  
  get isLoadingAutocompletePlaces$(): Observable<boolean> {
    return this.baseSearchbarfacade.isLoadingAutocompletePlaces$;
  }

  public placeInputChanged(input: ChangeInputPayload): void {
    if (input.isEmpty) this.baseSearchbarfacade.resetAutocomplete();
    else this.baseSearchbarfacade.searchPlaces(input.value);
  }
}
